<template>
    <div>
        <template v-if="isLoadingData">
            <SpeenComponent :isAutomatic="true" :ringWidth="14" :spinnerSize="15" :isverticalAligned="true" />
        </template>
        <template v-else-if="!summedData || Object.keys(summedData).length === 0">
            <div class="alert alert-warning" role="alert">
                No hay datos disponibles para mostrar.
            </div>
        </template>
        <template v-else>
            <div class="container">
                <div class="row">
                    <div
                        class="col metric-card p-2 rounded-md shadow-sm border flex flex-col justify-center items-start">
                        <h6 class="font-medium mb-1 text-sm">Tiempo con OP</h6>
                        <span class="metric-value">
                            {{ summedData.workedTimeWithORParsed }}
                        </span>
                    </div>
                    <div
                        class="col metric-card p-2 rounded-md shadow-sm border flex flex-col justify-center items-start">
                        <h6 class="font-medium mb-1 text-sm">Tiempo óptimo</h6>
                        <span class="metric-value">
                            {{ summedData.optimalTimeParsed }}
                        </span>
                    </div>
                </div>
                <div class="row">
                    <div
                        class="col metric-card p-2 rounded-md shadow-sm border flex flex-col justify-center items-start">
                        <h6 class="font-medium mb-1 text-sm">OP finalizadas</h6>
                        <span class="metric-value">
                            {{ formatValue(summedData.ORFinishedQuantity, false, '', true) }}
                        </span>
                    </div>
                    <div
                        class="col metric-card p-2 rounded-md shadow-sm border flex flex-col justify-center items-start">
                        <h6 class="font-medium mb-1 text-sm">Promedio de cajas por hora</h6>
                        <span class="metric-value">
                            {{ formatValue(summedData.averageFinishedBoxesRatePerHour, false, '', false) }}
                        </span>
                    </div>
                    <div
                        class="col metric-card p-2 rounded-md shadow-sm border flex flex-col justify-center items-start">
                        <h6 class="font-medium mb-1 text-sm">Porcentaje de tiempo útil</h6>
                        <span class="metric-value">
                            {{ formatValue(summedData.worthTimePercentage, false, '%', false) }}
                        </span>
                    </div>
                </div>
                <div class="row">
                    <div
                        class="col metric-card p-2 rounded-md shadow-sm border flex flex-col justify-center items-start">
                        <h6 class="font-medium mb-1 text-sm">Cajas producidas</h6>
                        <span class="metric-value">
                            {{ formatValue(summedData.boxesProducedQuantity, false, '', true) }}
                        </span>
                    </div>
                    <div
                    class="col metric-card p-2 rounded-md shadow-sm border flex flex-col justify-center items-start">
                    <h6 class="font-medium mb-1 text-sm">Calidad</h6>
                    <span class="metric-value">
                        {{ formatValue(summedData.qualityRate, false, '%', false) }}
                    </span>
                    </div>
                </div>
                <div class="row">
                    <div
                        class="col metric-card p-2 rounded-md shadow-sm border flex flex-col justify-center items-start">
                        <h6 class="font-medium mb-1 text-sm">Bolsas producidas</h6>
                        <span class="metric-value">
                            {{ formatValue(summedData.bagsProducedQuantity, false, '', true) }}
                        </span>
                    </div>
                    <div
                        class="col metric-card p-2 rounded-md shadow-sm border flex flex-col justify-center items-start">
                        <h6 class="font-medium mb-1 text-sm">Bolsas usadas</h6>
                        <span class="metric-value">
                            {{ formatValue(summedData.bagsUsedInBoxesQuantity, false, '', true) }}
                        </span>
                    </div>
                </div>
                <div class="row">
                    <div
                        class="col metric-card p-2 rounded-md shadow-sm border flex flex-col justify-center items-start">
                        <h6 class="font-medium mb-1 text-sm">Peso acumulado</h6>
                        <span class="metric-value">
                            {{ formatValue(summedData.weightAccumulated, false, ' kg', false) }}
                        </span>
                    </div>
                    <div
                        class="col metric-card p-2 rounded-md shadow-sm border flex flex-col justify-center items-start">
                        <h6 class="font-medium mb-1 text-sm">Peso excedente</h6>
                        <span class="metric-value">
                            {{ formatValue(summedData.weightExcess, false, ' kg', false) }}
                        </span>
                    </div>
                </div>
            </div>
        </template>
    </div>
</template>


<script>
import SpeenComponent from '../../common/components/SpeenComponent.vue';
export default {
    name: "ConfectionProductionReportingSummedData",
    components: {
        SpeenComponent,
    },
    props: {
        summedData: {
            type: Object,
            required: true,
        },
        isLoadingData: {
            type: Boolean,
            default: false,
        },
    },
    methods: {
        formatValue(value, isTime = false, suffix = '', forceNoDecimals = false) {
            if (isTime || typeof value === 'string') {
                return value + suffix;
            }
            if (typeof value === 'number') {
                if (Number.isInteger(value) || forceNoDecimals) {
                    return new Intl.NumberFormat(undefined, { useGrouping: true }).format(value) + suffix;
                }
                const options = { minimumFractionDigits: 2, maximumFractionDigits: 2 };
                if ( suffix.trim() == 'kg') {
                    options.minimumFractionDigits = 3;
                    options.maximumFractionDigits = 3;
                }
                return new Intl.NumberFormat(undefined, options).format(value) + suffix;
            }
            return value;
        },
    },
};
</script>
